<template>
    <div class="audiovisualLibrary">
        <div class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item  :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item >大圣讲堂</el-breadcrumb-item>
            </el-breadcrumb>
            <!-- 标题 -->
            <h3 class="font-style-s">
                <img src="@/assets/imgs/yy/3@2x.png" alt="">
                大圣讲堂
                <img src="@/assets/imgs/yy/4@2x.png" alt="">
            </h3>
            <!-- tabs -->
            <div class="banner-title">
                <div v-for="(val,i) in meanLists"
                     :key="i"
                     :class="[detail.name === val.name && 'active']"
                     @click="handleMean(val)">{{val.name}}</div>
            </div>
            <!-- 内容 -->
            <div v-if="detail.categoryId === 7">
                <ul class="lists-box" >
                    <li v-for="(val,i) in lists" :key="i"  @click="handleDetail(val)">
                        <h5>{{val.title}}</h5>
                        <div class="date-time">
                            <label for="">
                                {{val.year}}年{{val.month}}月{{val.day}}日
                            </label>
                            <!-- <span>阅读 <i>{{val.browseCount}}次</i></span> -->
                        </div>
                        <p class="line-clamp3">{{val.introduction}}</p>
                        <img class="more" src="@/assets/imgs/more@3x.png" alt="">
                    </li>
                </ul>
                <div class="fs12" v-if="!lists.length">暂无数据</div>
                <el-pagination
                    background
                    class="pagination"
                    layout="prev, pager, next"
                    @current-change="handlePageChange"
                    :current-page="page"
                    :page-size="10"
                    :total="total">
                </el-pagination>
            </div>

            <!-- 知识问答 5-->
            <div v-if="detail.categoryId === 5" class="knowledge">
                <img v-if="!showQuestion"
                     @click="handleOpen"
                     src="@/assets/imgs/mmexport1756278809244.png"
                     alt="">
                <iframe v-if="showQuestion"
                        :src="meanLists[1].url"
                        frameborder="0"
                        width="100%"
                        height="500px"></iframe>
            </div>

            <!-- 在线测评 6-->
            <div v-if="detail.categoryId === 6" class="knowledge">
                <img v-if="!showQuestion" src="@/assets/imgs/mmexport1756278812169.png" alt="">
                <iframe v-if="showQuestion"
                        :src="meanLists[2].url"
                        frameborder="0"
                        width="100%"
                        height="500px"></iframe>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { articleLists } from '@/api/index';
import moment from 'moment';
import { useRoute, useRouter } from 'vue-router/composables';
const router = useRouter();
const route = useRoute();

const meanLists = ref([
    {
        name: '知识库',
        categoryId: 7
    },
    {
        name: '知识问答',
        categoryId: 5,
        url: 'https://survey.scxbwg.cn/s/zs5PZT'
    },
    {
        name: '在线测评',
        categoryId: 6,
        url: 'http://survey.scxbwg.cn/s/Zjw3nh'
    }
]);

const detail = ref({
    name: '知识库',
    categoryId: 7
});

const handleMean = (val) => {
    detail.value = val;
    showQuestion.value = false;
    if (val.categoryId === 7) {
        getZxLists();
    }
};

const lists = ref([]);
const showQuestion = ref(false);
const page = ref(1);

// 获取资讯列表
const getZxLists = () => {
    articleLists({
        pageNo: page.value,
        pageSize: 10,
        categoryId: detail.value.categoryId
    }).then(({ data }) => {
        console.log(data, 9090);
        const _data = data?.list || [];

        _data.forEach((element) => {
            element.year = moment(element.createTime).format('YYYY');
            element.month = moment(element.createTime).format('MM');
            element.day = moment(element.createTime).format('DD');
        });

        lists.value = _data;
        total.value = data?.total || 0;
    });
};

const handleDetail = (item) => {
    if (item.wechatUrl) {
        window.open(item.wechatUrl, '_blank');
    } else {
        router.push('/literatureLecture/detail?id=' + item.id + '&categoryId=' + 7);

    }
};

const handleOpen = () => {
    showQuestion.value = true;
};


onMounted(() => {
    const { index } = route.query;
    console.log(index, 99);
    detail.value = meanLists.value[index || 0];
    getZxLists();
});

const total = ref(0);
const handlePageChange = (val) => {
    page.value = val;
    getZxLists();
};

</script>

<style lang="scss" scoped>
.fs12{
    font-size: 14px;
}
.container{
    padding: 30px 0;

   h3{
        font-weight:700;
        color:#232323;
        font-size:24px;
        text-align:center;
        margin-bottom: 22px;
        margin-top: 18px;
        img{
            width: 24px;
            height: 37px;
            vertical-align: middle;
        }
    }
    ul{
        li{

            background: #fff;
            padding: 15px 18px;
            margin-bottom: 20px;
            cursor: pointer;
            img{
                width: 191px;
                height: 261px;
            }

                h5{
                    color:#232323;
                    font-size:24px;
                    margin-bottom: 20px;
                }
                .date-time{
                    color:#848484;
                    font-size:18px;
                    display: block;
                    border-bottom: 1px dotted rgba(#707070,0.4);

                    i{
                        font-style: normal;
                        color: #b45f5f;
                    }
                }
                p{
                    color:#848484;
                    font-size:18px;
                    margin-top: 15px;
                }
                a{
                    width: 87px;
                    height: 26px;
                    border: 1px solid;
                    border-color: #686868;
                    font-size: 14px;
                    margin-top: 78px;
                    text-align: center;
                    line-height: 26px;
                    color: #686868;
                    display: block;
                    cursor: pointer;
                }

        }
    }

    .pagination{
        margin: 100px auto;
        text-align: center;
    }

    .banner-title{
        margin-top: 44px;
        display: flex;
        gap:32px;
        justify-content: center;
        margin-bottom: 49px;
        > div{
            width: 229.9px;
            height: 56px;
            color:#4e4e4e;
            font-size:14px;
            // background: #ffffff;
            text-align: center;
            line-height: 60px;
            cursor: pointer;
            background: url('~@/assets/imgs/unchecked.png') no-repeat;
            background-size: cover;
        }
        .active{
             background: url('~@/assets/imgs/checked@3x.png') no-repeat;
             background-size: cover;
             color: #fff;
        }
    }
}
.knowledge{
    cursor: pointer;
    text-align: center;
    img{
        width: 727px;
        height: 297px;
    }
}
.more{
    width: 87px !important;
    height: 26px !important;
    cursor: pointer;
}
</style>
